import * as React from "react";
export class PlaceholderInfo extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-ev-list__placeholder__player-info" },
            React.createElement("div", { className: "rj-ev-list__placeholder__player-names-wrap" },
                React.createElement("div", { className: "rj-ev-list__placeholder__player-name" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__player-name" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-item-icon" })));
    }
}
//# sourceMappingURL=PlaceholderInfo.js.map